import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import debounce from "debounce";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../common/contexts/userContext";
import "./LeagueStyles.scss";
import ManageLeaguePanel from "./ManageLeaguePanel";
import MobileLeaguePanel from "./MobileLeaguePanel";
import SearchLeaguePanel from "./SearchLeaguePanel";
import YourLeaguesPanel from "./YourLeaguesPanel";

export interface MobileLeaguesProps {
  isUserSigned: boolean;
}

export const MobileLeagues = ({ isUserSigned }: MobileLeaguesProps) => {
  const [currentView, setCurrentView] = useState<LeagueViewTab>("Search");
  const [manageLeagueId, setManageLeagueId] = useState(0);
  const { user } = useUser();
  const showButton =
    (user.leagues ?? []).filter((league) => league.adminId === user.id).length < 3;

  return (
    <div className="mobileLeagues__root">
      {currentView !== "ManageLeagues" && (
        <MobileLeaguePanel
          setCurrentView={setCurrentView}
          currentView={currentView}
          paddingTop
        />
      )}
      <div className="mobileLeagues__body">
        {currentView === "Search" && <SearchLeaguePanel />}
        {currentView === "YourLeagues" && (
          <YourLeaguesPanel
            setManageLeagueId={setManageLeagueId}
            setCurrentView={setCurrentView}
          />
        )}
        {currentView === "ManageLeagues" && (
          <ManageLeaguePanel
            manageLeagueId={manageLeagueId}
            setCurrentView={setCurrentView}
          />
        )}

        {currentView !== "ManageLeagues" && showButton && (
          <div className="mobileLeagues__createWrap">
            <CreateLeagueButton />
          </div>
        )}
      </div>
    </div>
  );
};

export type LeagueViewTab = "Search" | "YourLeagues" | "ManageLeagues";

export const CreateLeagueButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<Add />}
      onClick={debounce(() => navigate("/createLeague"), 700)}
      className="createLeagueButton__root"
    >
      Create League
    </Button>
  );
};
